module.exports = __webpack_public_path__ + "img/dustkid_daily.6fa755d5.png";